import React, { Component } from 'react';
import { ThemeContext } from '../../../context/theme.context';
import '../style.css';
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Legend,
  Category,
  StackingColumnSeries,
  Tooltip,
  DataLabel,
  ILoadedEventArgs,
  LineSeries,
} from '@syncfusion/ej2-react-charts';
import { getTeamGraph } from '../../../services/KPIsServices/KPIsServices';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import Scheduler from '../../../components/GlobalScheduler';
import { BiRefresh } from 'react-icons/bi';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
interface IProps {}
interface IState {
  graph1Data: Array<any>;
  graph11DataShift: Array<any>;
  graph11DataException: Array<any>;
  graph2Data: Array<any>;
  graph3Data: Array<any>;
}
interface DataEntry {
  element_alias: string;
  dayName: string;
  y1: string;
  y0?: string;
}

interface MonthlyTotals {
  element_alias: string;
  dayName: string;
  y1: string;
  y0: string;
}
interface DataElement {
  element_alias: string | null;
  dayName: string;
  y0?: string;
  y1?: string;
  y2?: string;
  y3?: string;
  y4?: string;
}
export default class TeamChart extends Component<IProps, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private graph1Teams: Array<any> = [];
  private graph1Tickets: Array<any> = [];
  private graph2Teams: Array<any> = [];
  private graph2Tickets: Array<any> = [];
  private graph3Teams: Array<any> = [];
  private OneMonthList: Array<any> = [];
  private ThreeMonthList: Array<any> = [];
  private OneWeekBool: boolean = false;
  private TwoWeeksBool: boolean = false;
  private OneMonthbool: boolean = false;
  private ThreeMonthbool: boolean = false;
  private graph3Tickets: Array<any> = [];
  private grap1Obj: ChartComponent;
  private grap2Obj: ChartComponent;
  private grap3Obj: ChartComponent;
  private listObj: ListViewComponent;
  public lastlist: DataElement[] = [];
  constructor(props: IProps) {
    super(props);
    this.state = {
      graph1Data: [],
      graph2Data: [],
      graph11DataShift: [],
      graph3Data: [],
      graph11DataException: [],
    };
    this.grap1Obj = new ChartComponent(props);
    this.grap2Obj = new ChartComponent(props);
    this.grap3Obj = new ChartComponent(props);
    this.listObj = new ListViewComponent(props);
  }
  public maxvalue: number = 0;
  public onChartLoad(args: ILoadedEventArgs): void {}
  public load(args: ILoadedEventArgs): void {}
  private baseColor = 'e36927';
  private colors = [
    '#7a42db',
    '#db6b16',
    '#db3016',
    '#30ed13',
    '#696969',
    '#22799c',
    '#db6b16',
    '#81a391',
    '#8216db',
    '#8e18c9',
    '#f2eeb8',
    '#00b6ff',
    '#2a1140',
    '#d736e3',
    '#d1c40f',
    '#a971ad',
    '#6c5f73',
    '#e6e3e8',
    '#f097b0',
    '#73eb89',
  ];
  generateColor(color: string, index: number) {
    return this.colors[index];
  }

  componentDidMount() {
    this.getTeamsGraph(Scheduler.AllFilterDAta);
  }
  generateInitialFilter = () => {
    let date = new Date();
    const startDate = date.getMonth() + 1 + '/' + 1 + '/' + date.getFullYear();
    const endDate =
      date.getMonth() +
      1 +
      '/' +
      new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate() +
      '/' +
      date.getFullYear();
    var alias = '';
    alias = alias.replace(/.$/, '');
    const asignments: any = [];
    return `'${startDate}'$'${endDate}'$${asignments}$${alias}`;
  };
  formatMonth = (month: number): string => {
    return month < 10 ? `0${month}` : `${month}`;
  };
  getFirstThreeMonthsData(data: DataElement[]): DataElement[] {
    const parseDate = (dateStr: string): Date => {
      var [day, month, year] = dateStr.split('-').map(Number);
      year = 2000 + year;
      return new Date(year, month - 1, day);
    };

    data.sort(
      (a, b) => parseDate(a.dayName).getTime() - parseDate(b.dayName).getTime()
    );

    const months: { [key: string]: DataElement } = {};
    const results: DataElement[] = [];

    data.forEach((item) => {
      const date = parseDate(item.dayName);
      const monthKey = `${this.formatMonth(
        date.getMonth() + 1
      )}-${date.getFullYear()}`;

      if (!months[monthKey]) {
        months[monthKey] = {
          element_alias: item.element_alias,
          dayName: monthKey,
        };
      }

      const addValue = (key: 'y0' | 'y1' | 'y2' | 'y3' | 'y4') => {
        const currentValue = parseFloat(months[monthKey][key] || '0');
        const newValue = parseFloat(item[key] || '0');
        months[monthKey][key] = (currentValue + newValue).toString();
      };

      addValue('y0');
      addValue('y1');
      addValue('y2');
      addValue('y3');
      addValue('y4');
    });

    Object.keys(months)
      .slice(0, 3)
      .forEach((key) => {
        results.push(months[key]);
      });

    return results;
  }
  parseDate = (dayName: string): Date => {
    const [day, month, year] = dayName.split('-').map(Number);
    // Yıl bilgisini atlayıp mevcut yılı kullanarak tarih oluşturuyoruz
    const currentYear = new Date().getFullYear();
    return new Date(currentYear, month - 1, day);
  };

  formatDayName = (dayName: string): string => {
    const [day, month] = dayName.split('-').map(Number);
    return `${String(day).padStart(2, '0')}-${String(month).padStart(2, '0')}`;
  };
  addDays = (date: Date, days: number): Date => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  };
  getElementsForNDays = (
    data: DataElement[],
    numDays: number
  ): DataElement[] => {
    if (data.length === 0) {
      return [];
    }

    const startDate = this.parseDate(data[0].dayName);
    const endDate = this.addDays(startDate, numDays - 1);

    return data
      .filter((item) => {
        const currentDate = this.parseDate(item.dayName);
        return currentDate >= startDate && currentDate <= endDate;
      })
      .map((item) => ({
        ...item,
        dayName: this.formatDayName(item.dayName),
      }));
  };

  formatDateRange(startDate: Date, endDate: Date): string {
    const format = (date: Date) => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      return `${day}-${month}`;
    };
    return `${format(startDate)} - ${format(endDate)}`;
  }
  getTeamsGraph(query: string) {
    this.graph1Teams = [];
    this.graph2Teams = [];
    this.graph3Teams = [];
    this.graph1Tickets = [];
    this.graph2Tickets = [];
    this.graph3Tickets = [];
    getTeamGraph(query)
      .then((el) => {
        el?.data?.dataG3?.sort((a: any, b: any) => {
          const [dayA, monthA, yearA] = a.dayName.split('-').map(Number);
          const [dayB, monthB, yearB] = b.dayName.split('-').map(Number);

          const dateA = new Date(2000 + yearA, monthA - 1, dayA);
          const dateB = new Date(2000 + yearB, monthB - 1, dayB);

          return dateA.getTime() - dateB.getTime();
        });
        this.designData1(el.data.dataG1, this.graph1Tickets, this.graph1Teams);
        this.designData2(el.data.dataG2, this.graph2Tickets, this.graph2Teams);
        this.designData3(el.data.dataG3, this.graph3Tickets, this.graph3Teams);

        const theShift: Array<any> = [];
        const theException: Array<any> = [];
        el.data.dataG4.map((el: any) => {
          if (el.roster_type === 'Shift') {
            theShift.push({
              team_code: el.team_code,
              type: el.roster_type,
              Y: (el.Y / 60).toFixed(2),
            });
          } else {
            theException.push({
              team_code: el.team_code,
              type: el.roster_type,
              Y: (el.Y / 60).toFixed(2),
            });
          }
        });

        if (this.OneMonthbool) {
          this.lastlist = this.getElementsForNDays(this.graph3Teams, 30);
        } else if (this.ThreeMonthbool) {
          this.lastlist = this.getFirstThreeMonthsData(this.graph3Teams);
        } else if (this.OneWeekBool) {
          this.lastlist = this.getElementsForNDays(this.graph3Teams, 7);
        } else if (this.TwoWeeksBool) {
          this.lastlist = this.getElementsForNDays(this.graph3Teams, 14);
        } else {
          this.lastlist = this.graph3Teams;
        }
        console.log('lastlist');
        console.log(this.lastlist);
        this.maxvalue = 0;
        this.lastlist.map((eachdata) => {
          if (eachdata.y0 && eachdata.y1) {
            if (parseInt(eachdata.y0) + parseInt(eachdata.y1) > this.maxvalue) {
              this.maxvalue = parseInt(eachdata.y0) + parseInt(eachdata.y1);
            }
          }
        });

        this.setState({
          graph11DataShift: theShift,
          graph11DataException: theException,
          graph1Data: this.graph1Teams,
          graph2Data: this.graph2Teams,
          graph3Data: this.lastlist,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }
  designData1(data: Array<any>, tickets: Array<any>, outPut: Array<any>) {
    var counter: number = 0;
    data.forEach((el: any, index: number) => {
      data[index].trade_code =
        el.trade_code === '' ? 'NO TRADE' : el.trade_code;
      data[index].team_code = el.team_code === '' ? 'NO TEAM' : el.team_code;
      var foundIndex = tickets.findIndex((elin) => {
        return (
          (elin.value === el.trade_code && elin.type === el.type) ||
          (elin.value === 'Exception' && el.type === 'Exception')
        );
      });

      if (foundIndex === -1 || foundIndex === undefined) {
        if (el.type === 'Exception') {
          tickets.push({
            y: `y${counter}`,
            value: el.type,
            color: el.type === 'Exception' ? '#789395' : el.color,
            type: el.type,
          });
        } else {
          tickets.push({
            y: `y${counter}`,
            value: el.trade_code,
            color: el.color,
            type: el.type,
          });
        }
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = outPut.findIndex((elin) => {
        return elin.team_code === element.team_code;
      });
      var paramName: any = [];
      if (element.type === 'Shift') {
        paramName = tickets.filter((el) => el.value === element.trade_code);
      } else {
        paramName = tickets.filter((el) => el.value === 'Exception');
      }
      if (foundIndex != -1) {
        outPut[foundIndex][paramName[0].y] = Math.abs(element.Y / 60).toFixed(
          2
        );
      } else {
        outPut.push({
          trade_code: element.trade_code,
          team_code: element.team_code,
          [paramName[0].y]: Math.abs(
            (element.Y / 60).toFixed(2) as unknown as number
          ),
        });
      }
    });
  }
  designData2(data: Array<any>, tickets: Array<any>, outPut: Array<any>) {
    var counter: number = 0;
    data.forEach((el: any, index: number) => {
      data[index].trade_code =
        el.trade_code === '' ? 'NO TRADE' : el.trade_code;
      data[index].team_code = el.team_code === '' ? 'NO TEAM' : el.team_code;
      const foundIndex = tickets.findIndex((elin) => {
        return elin.value === el.element_alias;
      });
      if (foundIndex === -1 || foundIndex === undefined) {
        tickets.push({
          y: `y${counter}`,
          value: el.element_alias,
          color: el.shift_color,
        });
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = this.graph2Teams.findIndex((elin) => {
        return elin.team_code === element.team_code;
      });
      const paramName = tickets.filter(
        (el) => el.value === element.element_alias
      );
      if (foundIndex != -1) {
        this.graph2Teams[foundIndex][paramName[0].y] = Math.abs(
          element.Y / 60
        ).toFixed(2);
      } else {
        this.graph2Teams.push({
          element_alias: element.element_alias,
          team_code: element.team_code,
          [paramName[0].y]: Math.abs(element.Y / 60).toFixed(2),
        });
      }
    });
  }
  designData3(data: Array<any>, tickets: Array<any>, outPut: Array<any>) {
    var counter: number = 0;
    data.forEach((el: any) => {
      const foundIndex = tickets.findIndex((elin) => {
        return elin.value === el.element_alias;
      });
      if (foundIndex === -1 || foundIndex === undefined) {
        tickets.push({
          y: `y${counter}`,
          value: el.element_alias,
          color: el.shift_color,
        });
        counter++;
      }
    });
    data.forEach((element: any) => {
      const foundIndex = outPut.findIndex((elin) => {
        return elin.dayName === element.dayName;
      });
      const paramName = tickets.filter(
        (el) => el.value === element.element_alias
      );
      if (foundIndex != -1) {
        outPut[foundIndex][paramName[0].y] = Math.abs(element.Y / 60).toFixed(
          2
        );
      } else {
        outPut.push({
          element_alias: element.element_alias,
          dayName: element.dayName,
          [paramName[0].y]: Math.abs(element.Y / 60).toFixed(2),
        });
      }
    });
  }
  renderTemplateListElement = (el: any) => {
    return (
      <div className='eachPiece' style={{ fontSize: 10 }}>
        <div className='line'></div>
        <div className='eachTexts'>
          <span className='eachTeamText'>
            {el.team_code === '' ? 'NO TEAM' : el.team_code}
          </span>
          <span className='eachTeamCountText'>{Math.abs(el.Y)}</span>
        </div>
      </div>
    );
  };
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any,
    OneMonth?: boolean,
    ThreeMonths?: boolean
  ) {
    // if () {

    // }
    if (this.state != prevState) {
      return;
    }
    if (this.context.isDataChangeKpiTeam) {
      this.getTeamsGraph(Scheduler.AllFilterDAta);
      this.context.setDataChangeKpiTeam(false);
    }
  }
  render() {
    return (
      <div className='main-chart-content'>
        <BiRefresh
          size={23}
          onClick={() => {
            this.grap1Obj.refresh();
            this.grap3Obj.refresh();
            this.grap2Obj.refresh();
          }}
        />
        <div className='chart1' style={{ width: '24vw' }}>
          <div className='left-component-first'>
            <span>
              <b># of Hours By Team</b>
            </span>
          </div>
          <div className='left-component-three'>
            <ChartComponent
              id='teamcharts'
              style={{ textAlign: 'center' }}
              ref={(el) => {
                this.grap1Obj = el as ChartComponent;
              }}
              primaryXAxis={{
                majorGridLines: { width: 0 },
                minorGridLines: { width: 0 },
                majorTickLines: { width: 0 },
                minorTickLines: { width: 0 },

                lineStyle: { width: 0 },
                labelIntersectAction: 'Rotate45',
                valueType: 'Category',
                labelStyle: {
                  size: '8px',
                },
              }}
              primaryYAxis={{
                lineStyle: { width: 0 },
                majorTickLines: { width: 1 },
                majorGridLines: { width: 0 },
                minorGridLines: { width: 1 },
                minorTickLines: { width: 1 },
                labelFormat: '{value}',
                labelStyle: {
                  size: '8px',
                },
              }}
              width={'100%'}
              delayUpdate
              chartArea={{ border: { width: 0 } }}
              load={this.load.bind(this)}
              loaded={this.onChartLoad.bind(this)}
              tooltip={{ enable: true }}
              height={'190px'}
              background={this.context.isDarkMode ? '#15202B' : '#EAEAEA'}
              legendSettings={{
                textStyle: {
                  color: this.context.isDarkMode ? '#EAEAEA' : '#15202B',
                  size: '8px',
                },
                position: 'Top',
              }}
            >
              <Inject
                services={[
                  StackingColumnSeries,
                  LineSeries,
                  Category,
                  Legend,
                  Tooltip,
                ]}
              />
              <SeriesCollectionDirective>
                {this.graph1Tickets.map((el: any, index: number) => {
                  if (el.type === 'Exception') {
                    return (
                      <SeriesDirective
                        zOrder={1000000}
                        key={Math.random()}
                        dataSource={this.state.graph1Data}
                        xName='team_code'
                        yName={`y${index}`}
                        animation={{ enable: true }}
                        name={el.value}
                        type='Line'
                        fill={el.color}
                        marker={{ visible: true, width: 10, height: 10 }}
                      ></SeriesDirective>
                    );
                  } else {
                    return (
                      <SeriesDirective
                        zOrder={1}
                        key={Math.random()}
                        dataSource={this.state.graph1Data}
                        xName='team_code'
                        yName={`y${index}`}
                        name={el.value}
                        type='StackingColumn'
                        fill={el.color}
                        cornerRadius={{
                          topLeft: 0,
                          topRight: 0,
                        }}
                      ></SeriesDirective>
                    );
                  }
                })}
              </SeriesCollectionDirective>
            </ChartComponent>
          </div>
          <div className='left-component-fourr'></div>
        </div>
        <div className='chart2' style={{ width: '24vw' }}>
          <div className='blanc-text'>
            <span>
              <b># of Hours by Exception Element</b>
            </span>
          </div>
          <ChartComponent
            id='teamcharts2'
            style={{ textAlign: 'center' }}
            ref={(el) => {
              this.grap2Obj = el as ChartComponent;
            }}
            primaryXAxis={{
              majorGridLines: { width: 0 },
              minorGridLines: { width: 0 },
              majorTickLines: { width: 0 },
              minorTickLines: { width: 0 },
              interval: 1,
              lineStyle: { width: 0 },
              labelIntersectAction: 'Rotate45',
              labelStyle: {
                size: '8px',
              },
              valueType: 'Category',
            }}
            primaryYAxis={{
              lineStyle: { width: 0 },
              majorTickLines: { width: 1 },
              majorGridLines: { width: 0 },
              minorGridLines: { width: 1 },
              minorTickLines: { width: 1 },
              labelStyle: {
                size: '8px',
              },
              labelFormat: '{value}',
            }}
            width={'100%'}
            enableAnimation={true}
            chartArea={{ border: { width: 0 } }}
            load={this.load.bind(this)}
            loaded={this.onChartLoad.bind(this)}
            tooltip={{ enable: true }}
            height={'190px'}
            background={this.context.isDarkMode ? '#15202B' : '#EAEAEA'}
            legendSettings={{
              textStyle: {
                color: this.context.isDarkMode ? '#EAEAEA' : '#15202B',
                size: '8px',
              },
              position: 'Top',
            }}
          >
            <Inject
              services={[StackingColumnSeries, Category, Legend, Tooltip]}
            />
            <SeriesCollectionDirective>
              {this.graph2Tickets.map((el: any, index: number) => {
                return (
                  <SeriesDirective
                    key={Math.random()}
                    dataSource={this.state.graph2Data}
                    xName='team_code'
                    yName={`y${index}`}
                    name={el.value}
                    type='StackingColumn'
                    fill={el.color}
                  ></SeriesDirective>
                );
              })}
            </SeriesCollectionDirective>
          </ChartComponent>
        </div>
        <div className='chart3' style={{ width: '24vw' }}>
          <div className='flex '>
            <b># of Hours by Exception Element</b>
            <div>
              <ButtonComponent
                style={{
                  height: '30px',
                  backgroundColor: this.OneWeekBool ? 'white' : '',
                  marginBottom: '5px',
                }}
                onClick={() => {
                  this.OneWeekBool = !this.OneWeekBool;
                  this.TwoWeeksBool = false;
                  this.OneMonthbool = false;
                  this.ThreeMonthbool = false;
                  this.getTeamsGraph(Scheduler.AllFilterDAta);
                }}
              >
                <p style={{ color: this.OneWeekBool ? 'black' : '' }}>1 Week</p>
              </ButtonComponent>

              <ButtonComponent
                style={{
                  height: '30px',
                  backgroundColor: this.TwoWeeksBool ? 'white' : '',
                  marginBottom: '5px',
                }}
                onClick={() => {
                  this.OneWeekBool = false;
                  this.TwoWeeksBool = !this.TwoWeeksBool;
                  this.OneMonthbool = false;
                  this.ThreeMonthbool = false;
                  this.getTeamsGraph(Scheduler.AllFilterDAta);
                }}
              >
                <p style={{ color: this.TwoWeeksBool ? 'black' : '' }}>
                  2 Weeks
                </p>
              </ButtonComponent>

              <ButtonComponent
                className='butonclass'
                style={{
                  height: '30px',
                  backgroundColor: this.OneMonthbool ? 'white' : '',
                  marginBottom: '5px',
                }}
                onClick={() => {
                  this.OneWeekBool = false;
                  this.TwoWeeksBool = false;
                  this.OneMonthbool = !this.OneMonthbool;
                  this.ThreeMonthbool = false;
                  this.getTeamsGraph(Scheduler.AllFilterDAta);
                }}
              >
                <p style={{ color: this.OneMonthbool ? 'black' : '' }}>
                  1 Month
                </p>
              </ButtonComponent>

              <ButtonComponent
                style={{
                  height: '30px',
                  backgroundColor: this.ThreeMonthbool ? 'white' : '',
                  marginBottom: '5px',
                }}
                onClick={() => {
                  this.OneWeekBool = false;
                  this.TwoWeeksBool = false;
                  this.OneMonthbool = false;
                  this.ThreeMonthbool = !this.ThreeMonthbool;
                  this.getTeamsGraph(Scheduler.AllFilterDAta);
                }}
              >
                <p style={{ color: this.ThreeMonthbool ? 'black' : '' }}>
                  3 Months
                </p>
              </ButtonComponent>
            </div>
          </div>
          <div>
            <ChartComponent
              id='teamcharts3'
              style={{ textAlign: 'center' }}
              ref={(el) => {
                this.grap3Obj = el as ChartComponent;
              }}
              primaryXAxis={{
                valueType: 'Category',
                labelIntersectAction: 'Rotate45',
                labelStyle: {
                  size: '8px',
                },
                majorGridLines: { width: 0 },
                minorGridLines: { width: 0 },
                majorTickLines: { width: 0 },
                minorTickLines: { width: 0 },
              }}
              primaryYAxis={{
                rangePadding: 'None',
                interval: Math.round(Math.round(this.maxvalue / 5) / 10) * 10,
                majorTickLines: { width: 1 },
                majorGridLines: { width: 0 },
                minorGridLines: { width: 1 },
                minorTickLines: { width: 1 },
                labelStyle: {
                  size: '8px',
                },
                lineStyle: {
                  width: 0,
                },
              }}
              width={'100%'}
              chartArea={{ border: { width: 0 } }}
              load={this.load.bind(this)}
              loaded={this.onChartLoad.bind(this)}
              tooltip={{
                enable: true,
                format: '${point.x} : <b>${point.y} (${point.percentage}%)</b>',
              }}
              height={'190px'}
              background={this.context.isDarkMode ? '#15202B' : '#EAEAEA'}
              legendSettings={{
                textStyle: {
                  color: this.context.isDarkMode ? '#EAEAEA' : '#15202B',
                  size: '8px',
                },
                position: 'Top',
              }}
            >
              <Inject
                services={[
                  StackingColumnSeries,
                  Legend,
                  Tooltip,
                  DataLabel,
                  Category,
                ]}
              />
              <SeriesCollectionDirective>
                {this.graph3Tickets.map((el: any, index: number) => {
                  return (
                    <SeriesDirective
                      key={Math.random()}
                      dataSource={this.state.graph3Data}
                      xName='dayName'
                      yName={`y${index}`}
                      name={el.value}
                      type='StackingColumn'
                      fill={el.color}
                    ></SeriesDirective>
                  );
                })}
              </SeriesCollectionDirective>
            </ChartComponent>
          </div>
        </div>
        <div style={{ flexDirection: 'row', display: 'flex', width: '20%' }}>
          {this.state.graph11DataShift.length > 0 ? (
            <div style={{ flexDirection: 'column', display: 'flex' }}>
              <span>Shift</span>
              <ListViewComponent
                ref={(e) => {
                  this.listObj = e as ListViewComponent;
                }}
                className={'hiddenListElement'}
                id='sample-list-flat'
                dataSource={this.state.graph11DataShift}
                template={this.renderTemplateListElement.bind(this)}
                cssClass='e-list-template'
                animation={{
                  effect: 'SlideLeft',
                  duration: 500,
                  easing: 'ease',
                }}
                height={'200px'}
              ></ListViewComponent>
            </div>
          ) : null}
          {this.state.graph11DataException.length > 0 ? (
            <div style={{ flexDirection: 'column', display: 'flex' }}>
              <span>Exception</span>
              <ListViewComponent
                ref={(e) => {
                  this.listObj = e as ListViewComponent;
                }}
                className={'hiddenListElement'}
                id='sample-list-flat'
                dataSource={this.state.graph11DataException}
                template={this.renderTemplateListElement.bind(this)}
                cssClass='e-list-template'
                animation={{
                  effect: 'SlideLeft',
                  duration: 500,
                  easing: 'ease',
                }}
                height={'200px'}
              ></ListViewComponent>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
